import { useSupabaseFeatureFlags } from "./useSupabaseFeatureFlags";

export function useGoogleOAuthEnabled(): boolean {
  const { flags, isLoading } = useSupabaseFeatureFlags();

  if (isLoading) {
    return false; // Default to disabled while loading
  }

  const googleOAuthFlag = flags.find((flag) => flag.name === "google_oauth_enabled");
  return googleOAuthFlag?.enabled ?? false;
}
